let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h4k4y"), load("15VrD"), load("c5uOY"), load("6aruy")]).then(() => parcelRequire('9VKkC'));